import React from 'react'
import styled from 'styled-components'
import { motion } from 'framer-motion';
import { MobileSize } from '../responsive/MobileSize';

const Container = styled(motion.div)`
    position: absolute;
    top: 20px;
    right: 20px; 
    z-index: 1;
    display: flex;
    align-items: center;
    background-color: ${props => props.theme.text};
    padding: 5px 10px;
    border-radius: 10px;
    cursor: pointer;
    @media only screen and (max-width: 768px){
      right: 10px;
      border: 2px solid ${props => props.theme.body};
    }
`;

const Icon = styled.div`
    background-image: url(${props => props.icon});
    background-position: center;
    background-size: cover;
    height: 30px;
    width: 30px;
    margin-right: 5px;
    ${MobileSize({ height: "15px", width: "15px" })};
`;

const Text = styled.div`
  color: ${props => props.theme.body};
  ${MobileSize({ fontSize: "12px" })};
`;

export const SwitchThemeButton = ({icon, text, onClick}) => {
  return (
    <Container onClick={onClick} whileHover={{scale: 1.1}} whileTap={{scale: 0.9}}>
      <Icon icon={icon}/>
      <Text>{text}</Text>
    </Container>
  )
}
